import {Icon, IconProps} from '@chakra-ui/react';

export const ArchiveIcon: React.FC<IconProps> = (props) => (
  <Icon
    viewBox='0 0 21 18'
    {...props}
  >
    <path
      d='M1.96875 1.92857V3.85714H19.0312V1.92857H1.96875ZM1.3125 0H19.6875C20.4135 0 21 0.574554 21 1.28571V4.5C21 5.21116 20.4135 5.78571 19.6875 5.78571H1.3125C0.586523 5.78571 0 5.21116 0 4.5V1.28571C0 0.574554 0.586523 0 1.3125 0ZM6.5625 8.67857C6.5625 8.1442 7.00137 7.71429 7.54688 7.71429H13.4531C13.9986 7.71429 14.4375 8.1442 14.4375 8.67857C14.4375 9.21295 13.9986 9.64286 13.4531 9.64286H7.54688C7.00137 9.64286 6.5625 9.21295 6.5625 8.67857ZM1.3125 15.4286V7.07143H3.28125V15.4286C3.28125 15.7821 3.57656 16.0714 3.9375 16.0714H17.0625C17.4234 16.0714 17.7188 15.7821 17.7188 15.4286V7.07143H19.6875V15.4286C19.6875 16.8469 18.5104 18 17.0625 18H3.9375C2.48965 18 1.3125 16.8469 1.3125 15.4286Z'
      fill='currentColor'
    />
  </Icon>
);
